import React, { memo } from 'react';
import TwitterButton from './TwitterButton';
import FbButton from './FbButton';
import Grid, { GridProps } from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStylesOptions } from '@material-ui/styles/withStyles';

type StyledGridProps = GridProps & { gutterBottom: boolean };

const StyledGrid = withStyles<
  'root',
  WithStylesOptions<Theme>,
  StyledGridProps
>((theme) => ({
  root: {
    paddingBottom: (props) => theme.spacing(props.gutterBottom ? 4 : 0),
  },
}))(({ gutterBottom, ...props }: StyledGridProps) => <Grid {...props} />);

export interface ShareButtonGroupProps {
  loaded: boolean;
  justify?: GridProps['justify'];
  gutterBottom?: boolean;
  tweetText: string;
  tweetUrl?: string;
  hashtags?: string;
  url: string;
}

const ShareButtonGroup = memo(
  ({
    loaded,
    justify = 'flex-start',
    gutterBottom = false,
    tweetText,
    tweetUrl,
    hashtags,
    url,
  }: ShareButtonGroupProps) => (
    <StyledGrid
      container
      spacing={1}
      justify={justify}
      gutterBottom={gutterBottom}
    >
      <Grid item>
        <TwitterButton
          loaded={loaded}
          text={tweetText}
          tweetUrl={tweetUrl}
          hashtags={hashtags}
        />
      </Grid>
      <Grid item>
        <FbButton loaded={loaded} url={url} />
      </Grid>
    </StyledGrid>
  ),
);

export default ShareButtonGroup;
